const actions = {
  SET_STATE: 'auth/SET_STATE',
  LOGIN: 'auth/LOGIN',
  LOAD_CURRENT_ACCOUNT: 'auth/LOAD_CURRENT_ACCOUNT',
  LOGOUT: 'auth/LOGOUT',
}

export default actions
